
export const text = `

Wodin = he/him/ they/them
Wanderer = you/your they/them
Wanda = she/her they/them

`